import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  exteriorName: {
    id: 'exteriorName',
    description: 'Exterior',
    defaultMessage: 'Exterior',
  },
  interiorName: {
    id: 'interiorName',
    description: 'Interior',
    defaultMessage: 'Interior',
  },
  wheelName: {
    id: 'wheelName',
    description: 'Wheel',
    defaultMessage: 'Wheel',
  },
  trimName: {
    id: 'trimName',
    description: 'Trim',
    defaultMessage: 'Trim',
  },
  increasePrice: {
    id: 'increasePrice',
    description: 'Price will increase by',
    defaultMessage: 'Price will increase by',
  },
  decreasePrice: {
    id: 'decreasePrice',
    description: 'Price will decrease by',
    defaultMessage: 'Price will decrease by',
  },
  changePriceBand: {
    id: 'changePriceBand',
    description: 'Price band will change to',
    defaultMessage: 'Price band will change to',
  },
});
